module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-18-9b1db35c583a39ff0521426744d0b11e.jpg";